import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ia } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';

const DEFAULT_ERROR_TITLE = "Couldn't complete the action";
const DEFAULT_SUCCESS_TITLE = 'Action completed';
const DEFAULT_ERROR_MESSAGE = "You don't have permission to perform this action";
const DANGER_COLOR = 'danger';
const SUCCESS_COLOR = 'success';

export const useCustomMutation = ({
  mutationFn,
  successMessage,
  errorMessage,
  invalidateQueryKey,
  refetchQueryKey,
  onSuccess = () => {},
  handleResponse,
  disableAlert = false
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: (data, variables, context) => {
      switch (data?.code) {
        case 0:
          {
            onSuccess(data, variables, context);
            const message =
              typeof successMessage === 'function'
                ? successMessage(data)
                : successMessage || DEFAULT_SUCCESS_TITLE;

            if (!disableAlert && typeof successMessage !== 'function') {
              showAlert({
                title: message,
                color: data?.data?.color || SUCCESS_COLOR
              });
            }

            if (invalidateQueryKey) {
              if (ia(invalidateQueryKey)) {
                invalidateQueryKey.forEach((key) => {
                  if (ia(key)) queryClient.invalidateQueries({ queryKey: key });
                  else queryClient.invalidateQueries({ queryKey: [key] });
                });
                break;
              }

              queryClient.invalidateQueries({ queryKey: [invalidateQueryKey] });
            }

            if (refetchQueryKey) {
              if (ia(refetchQueryKey)) {
                refetchQueryKey.forEach((key) => {
                  if (ia(key)) queryClient.refetchQueries({ queryKey: key });
                  else queryClient.refetchQueries({ queryKey: [key] });
                });
                break;
              }

              queryClient.refetchQueries({ queryKey: [refetchQueryKey] });
            }
          }
          break;
        case 2:
          if (!disableAlert) {
            showAlert({
              title: DEFAULT_ERROR_MESSAGE,
              color: DANGER_COLOR
            });
          }
          break;
        default: {
          if (typeof handleResponse === 'function') {
            handleResponse(data);
            break;
          }

          if (!disableAlert) {
            showAlert({
              title: errorMessage || data?.error || DEFAULT_ERROR_TITLE,
              color: DANGER_COLOR
            });
          }
          break;
        }
      }
    },
    onError: (data) => {
      if (!disableAlert) {
        showAlert({
          title: data?.error || errorMessage,
          color: DANGER_COLOR
        });
      }
    }
  });
};
